import ApiService from './ApiService';

class SeoTextService extends ApiService {
    constructor() {
        super();
        this._attributeUrl = '/seo-text';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        return {...langHeader};
    }

    getSeoTexts(params) {
        return this.postResource(this._attributeUrl, params, this.getBaseHeaders());
    }
}

const service = new SeoTextService();

export default service;
